<template >
<div>
<div  v-for="obv in obvs" :key="obv.id">
   <div class="margin_bottom_kart"></div>
  <div class="kart">
    <router-link  :to="{name:'obv', params:{id:obv.id}}">
  <div>
  <table>
      <tr>
          <td>
              <div class="div_kart_img">
                  <clazy-load :src="obv.img_p">
                  <img :src="obv.img_p" class="kart_img" >
                  </clazy-load>
                  </div>
          </td>
          <td width="100%">
            <div class="margin_8-left">
                <label class="title_cbn">
                <span>{{obv.title}}</span>
                </label>
                <label class="sena"> 
                <div><b>{{obv.sena}} c.</b><span v-if = "obv.torg" class="torgest">Торг есть</span></div> 
                </label>
                <label class="opisanie">{{obv.body}}</label>
                <label class="adress">{{obv.gorod_text}}</label><br/>
                <label class="data_time">{{obv.dt}}</label>
                
            </div>
          </td>
      </tr>
  </table>
  </div>
 </router-link>
  </div>
</div>
</div>
</template>
<script>
export default {
  components:{
   
  },
     props: {
      obvs: Array,
     }, 
}
</script>
<style>
img[lazy="loading"]{
  display:block;
  width:50px !important;
  height:50px !important;
  margin:0 auto;
  }
.torgest{
  background-color: #1db781;
  padding:2px 4px 2px 4px;
  margin-left:2px;
  font-size: 14px;
  color:#fff;
  border-radius: 5px;
  display: inline-block;
}
</style>